/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_TitleInputs */

const vi_cashflow_title = /** @type {(inputs: Cashflow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo dòng tiền`)
};

/**

* @param {Cashflow_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_title = /** @type {((inputs?: Cashflow_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_title(inputs)
});